<template>
  <!-- NOTIFICATIONS -->
  <div class="flex-1 flex flex-col">
    <div class="notification-top text-center p-5 bg-primary text-white">
      <h3 class="text-white">{{ unreadNotif }}</h3>
      <p class="opacity-75">New GPS Alerts</p>
    </div>

    <ul class="bordered-items flex-1" style="overflow: scroll">
      <li
        v-for="ntf in unreadNotifications"
        :key="ntf.idx"
        class="flex justify-between px-4 py-4 notification"
        @click="navigateToStockAlert(ntf.idx, ntf.readStatus)"
      >
        <div class="flex items-start">
          <feather-icon
            icon="MessageSquareIcon"
            :svgClasses="[`text-warning`, 'stroke-current mr-1 h-6 w-6']"
          ></feather-icon>
          <div class="mx-2">
            <span
              class="font-medium block notification-title"
              :class="[`text-${ntf.category}`]"
              >{{ ntf.title }}</span
            >
            <small v-if="ntf.meta2==null || ntf.meta2==undefined">{{ ntf.msg }}</small>
            <ul v-else>
      <li v-for="item in JSON.parse(ntf.meta2)">
      <vs-button
                    :color="item.type == 'excel' ? 'success' : 'danger' "
                    @click="openLink(item.url)"
                    size="small"
                    type="flat"
                    :icon="item.type == 'excel'? 'description' :  'picture_as_pdf' "
                    >{{ item.name }}</vs-button>
      </li>
    </ul>

          </div>
        </div>
        <small class="mt-1 whitespace-no-wrap">{{ ntf.create_time }}</small>
      </li>
    </ul>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      unreadNotif: localStorage.getItem('unreadNotif'),
      unreadNotifications: JSON.parse(localStorage.getItem('unreadNotifications')),
    };
  },
  mounted() {
    const self = this;
    if (self.unreadNotif > 0) {
      this.$http
        .patch(`personals/notifications/${self.userInfo.uid}`)
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
          } else {
          }
        })
        .catch(function (error) {});
    }
  },
  methods: {
    openLink(url){
      window.open(
          url,
          '_blank',
        );
    }
  },
};
</script>
